<template>
    <div class="json-field">
        <div class="code-editor-container" :style="{ height: editorHeight }">
            <prism-editor
                v-model="jsonString"
                :highlight="highlighter"
                :line-numbers="true"
                @input="onChange"
                @blur="onBlur"
                class="code-editor"
                :placeholder="placeholder"
                :disabled="disabled"
                :class="{ 'is-invalid': jsonError }"
                ref="input"
            ></prism-editor>
            <div v-if="jsonError" class="invalid-feedback d-block">
                {{ jsonError }}
            </div>
        </div>
    </div>
</template>

<script>
import Json from './Json.js';
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css';
import 'prismjs/themes/prism-tomorrow.css';

export default {
    ...Json,
    components: {
        PrismEditor
    }
};
</script>

<style scoped>
.json-field {
    width: 100%;
    position: relative;
}

.code-editor-container {
    position: relative;
    width: 100%;
    border-radius: 3px;
    transition: all 0.3s ease;
    overflow: hidden;
    height: auto;
}

.code-editor {
    font-family: 'Fira Code', 'Fira Mono', Consolas, 'Courier New', monospace;
    font-size: 13px;
    line-height: 1.5;
    color: #333;
    background-color: #ffffff;
    border: 1px solid #e3e3e3;
    border-radius: 3px;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    max-height: 300px;
    min-height: px;
    overflow-y: auto;
}

.code-editor:hover {
    border-color: #b4b9be;
}

.code-editor:focus-within {
    border-color: #3699d2;
    outline: 0;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(54, 153, 210, 0.6);
}

.code-editor :deep(.prism-editor__textarea:focus) {
    outline: none;
}

.code-editor.is-invalid {
    border-color: #e74c3c;
}

.code-editor :deep(.prism-editor__line-numbers) {
    padding: 12px 10px;
    background-color: #f9fafb;
    color: #6b7280;
    border-right: 1px solid #e5e7eb;
    font-size: 12px;
}

.code-editor :deep(.prism-editor__line-number) {
    min-width: 2.5em;
    text-align: right;
    padding-right: 10px;
}

.invalid-feedback {
    margin-top: 6px;
    font-size: 13px;
    color: #e74c3c;
    line-height: 1.4;
}

/* Syntax highlighting for light theme */
:deep(.token.comment),
:deep(.token.prolog),
:deep(.token.doctype),
:deep(.token.cdata) {
    color: #6a737d;
}

:deep(.token.punctuation) {
    color: #4a5568;
}

:deep(.token.property),
:deep(.token.tag),
:deep(.token.boolean),
:deep(.token.number),
:deep(.token.constant),
:deep(.token.symbol),
:deep(.token.deleted) {
    color: #2f6f9f;
}

:deep(.token.selector),
:deep(.token.attr-name),
:deep(.token.string),
:deep(.token.char),
:deep(.token.builtin),
:deep(.token.inserted) {
    color: #3f6e74;
}

:deep(.token.operator),
:deep(.token.entity),
:deep(.token.url),
:deep(.language-css .token.string),
:deep(.style .token.string) {
    color: #a67f59;
}

:deep(.token.atrule),
:deep(.token.attr-value),
:deep(.token.keyword) {
    color: #9b59b6;
}

:deep(.token.function),
:deep(.token.class-name) {
    color: #dd4a68;
}

:deep(.token.regex),
:deep(.token.important),
:deep(.token.variable) {
    color: #e90;
}
</style>
